export default {
  refreshYourResults: 'Uppdatera dina resultat',
  weNeedTo: 'För senaste priser och tillgänglighet måste vi',
  refreshResults: 'uppdatera dina resultat.',
  okRefresh: 'Ok, uppdatera',
}
